module.exports = __webpack_public_path__ + "assets/icons/logo-cocolis-cad7.svg";